import { render } from "./testVendorChat.vue?vue&type=template&id=bc6fd100"
import script from "./testVendorChat.vue?vue&type=script&lang=js"
export * from "./testVendorChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__